<!--
   Created by qing on 2020/9/12
   Des: 关联表单展示数据view，和formData页面UI一致
-->
<template>
	<div class="form-data-view-container">

		<template
			v-if="[FORM_VIEW_TYPE_DATA_HANDLE, FORM_VIEW_TYPE_DATA_VIEW, FORM_VIEW_TYPE_PHOTO].includes(viewType)">
			<template v-if="loadingEnd && dataHandleOpts.totalCount > 0">
				<div class="header">
					<div class="des">
						共{{dataHandleOpts.totalCount}}条
					</div>
					<div style="display: flex; align-items: center;">

						<div
							style="margin-top: 5px;"
							@click="onClickBatchHandle"
							v-if="viewType === FORM_VIEW_TYPE_DATA_VIEW && !isBatchSelect && printPermission === 'YES'"
						>
							<svg
								t="1618560286267"
								class="icon"
								viewBox="0 0 1024 1024"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								p-id="1641"
								width="20"
								height="20"
							>
								<path
									d="M927 631.2c-19.3 0-35 15.7-35 35V733H254.5V130.8h127c19.3 0 35-15.7 35-35s-15.7-35-35-35h-162c-19.3 0-35 15.7-35 35V221H97c-19.3 0-35 15.7-35 35v672.1c0 19.3 15.7 35 35 35h707.5c19.3 0 35-15.7 35-35V802.9H927c19.3 0 35-15.7 35-35V666.2c0-19.4-15.7-35-35-35z m-157.5 262H132V291.1h52.5v476.8c0 19.3 15.7 35 35 35h550v90.3z"
									p-id="1642"
									fill="#E56833"
								></path>
								<path
									d="M458.8 571.8c55.1 55.1 128.4 85.5 206.3 85.5s151.2-30.4 206.3-85.5c55.1-55.1 85.5-128.4 85.5-206.3s-30.4-151.2-85.5-206.3c-55-55.2-128.3-85.5-206.2-85.5S513.9 104 458.8 159.1c-55.1 55.1-85.5 128.4-85.5 206.3s30.4 151.3 85.5 206.4z m206.4-428.1c122.3 0 221.8 99.5 221.8 221.8s-99.5 221.8-221.8 221.8c-122.3 0-221.8-99.5-221.8-221.8s99.5-221.8 221.8-221.8z"
									p-id="1643"
									fill="#E56833"
								></path>
								<path
									d="M624.6 451.3c6.8 6.8 15.8 10.3 24.7 10.3s17.9-3.4 24.7-10.3l123.7-123.7c13.7-13.7 13.7-35.8 0-49.5-13.7-13.7-35.8-13.7-49.5 0l-99 99-46.2-46.4c-13.7-13.7-35.8-13.7-49.5 0-13.7 13.7-13.7 35.8 0 49.5l71.1 71.1z"
									p-id="1644"
									fill="#E56833"
								></path>
							</svg>
						</div>

						<van-icon
							name="descending"
							@click="onClickSort"
						></van-icon>
						<van-icon
							v-if="false"
							name="filter-o"
							@click="onClickFilter"
						></van-icon>
					</div>
				</div>

				<div
					class="list-container"
					:style="{height: isBatchSelect ? 'calc(100% - 104px)' : 'calc(100% - 40px)'}"
				>
					<van-list
						v-if="dataHandleOpts.styleInfo"
						v-model="loading"
						:finished="finished"
						:immediate-check="false"
						finished-text="没有更多了"
						@load="onLoad"
					>
						<div
							:key="listKey"
							class="preview-container"
							v-if="dataHandleOpts.styleInfo.showType === 'CARD'"
						>
							<div
								class="preview-card"
								v-for="item in dataHandleOpts.dataList"
								@click="rowClick(item)"
								:key="item.instanceId"
							>
								<div class="card-top-container">
									<div
										v-if="isBatchSelect"
										style="display: flex; justify-content: center; align-items: center;"
									>
										<van-icon
											name="checked"
											color="#1989fa"
											v-if="selectList.map(s => s.item.instanceId).includes(item.item.instanceId)"
											@click.stop="itemSelectChange(false, item)"
										></van-icon>
										<van-icon
											name="circle"
											v-else
											@click.stop="itemSelectChange(true, item)"
										></van-icon>
									</div>
									<div class="preview-card-wrapper">
										<div
											class="card-tob-bj"
											v-if="dataHandleOpts.styleInfo.showColor"
											:style="{backgroundColor : item.color ? item.color.showData : ''}"
										></div>
										<div class="card-info">
											<p
												class="show-time"
												v-if="dataHandleOpts.styleInfo.showTime"
											>
												<span class="color">
												</span>
												{{actionFormatTime(item.time.showData,item.time.formatStr)}}
											</p>
											<h3 v-if="dataHandleOpts.styleInfo.showTitle">{{item.title.showData}}</h3>
											<div class="card-info-row">
												<div
													class="row-item"
													v-for="showData in item.content"
													:key="showData.dataId"
												>
													<h5>{{showData.fieldTitle}}</h5>
													<div class="item-content">
														<FieldShowData
															:show-data="showData"
															:memberShowType="dataHandleOpts.styleInfo.memberShowType"
														></FieldShowData>
													</div>
												</div>
											</div>
										</div>
										<div
											class="img-container"
											v-if="dataHandleOpts.styleInfo.showImage && item.image.showData"
										>

											<template v-if="item.image.fieldId.includes('IMAGE_')">
												<van-image
													:src="item.image.showData"
													fit="cover"
												></van-image>
											</template>

											<div v-else>
												<qriously
													:value="item.image.showData"
													:size="90"
												/>
											</div>
										</div>
									</div>
								</div>
								<div
									class="sub-table-container"
									v-if="dataHandleOpts.styleInfo.showTable === 'YES'"
								>
									<ScrollTable
										v-if="item.tableInfo.yList && item.tableInfo.yList.length"
										:y-list="item.tableInfo.yList"
										:x-field="item.tableInfo.xField"
										:x-list="item.tableInfo.xList"
										:width-info="item.tableInfo.widthInfo"
									></ScrollTable>
								</div>
							</div>
						</div>
						<div
							v-else
							:key="listKey"
							class="preview-container photo-container"
						>
							<div
								class="preview-photo"
								:style="{width: dataHandleOpts.styleInfo.showStyle === 'TWO_IN_LINE' ? 'calc(50% - 10px)' : 'calc(100% - 10px)'}"
								v-for="item in dataHandleOpts.dataList"
								:key="item.instanceId"
								@click="rowClick(item)"
							>
								<div
									v-if="isBatchSelect"
									style="display: flex; justify-content: center; align-items: center;"
								>
									<van-icon
										name="checked"
										color="#1989fa"
										v-if="selectList.map(s => s.item.instanceId).includes(item.item.instanceId)"
										@click.stop="itemSelectChange(false, item)"
									></van-icon>
									<van-icon
										name="circle"
										v-else
										@click.stop="itemSelectChange(true, item)"
									></van-icon>
								</div>

								<div>
									<div
										class="img-container"
										v-if="dataHandleOpts.styleInfo.showImage"
										:style="{height: dataHandleOpts.styleInfo.showStyle === 'TWO_IN_LINE' ? '200px' : '150px'}"
									>

										<template v-if="item.image.showData && item.image.showData.length > 0">

											<template v-if="item.image.fieldId.includes('IMAGE_')">
												<van-image
													@click.stop="onClickPreviewData(item.image, 0)"
													v-if="item.image.showData.length === 1"
													:src="item.image.showData[0].imgUrl"
													:fit="imageStyleMap[dataHandleOpts.styleInfo.imageStyle]"
												>
												</van-image>

												<van-swipe
													v-else
													:autoplay="dataHandleOpts.styleInfo.autoplay === 'YES' ? 3000 : 0"
													lazy-render
													style="height: 100%; width: 100%;"
												>
													<van-swipe-item
														v-for="(imgInfo, idx) in item.image.showData"
														:key="imgInfo.imgUrl"
													>
														<van-image
															@click.stop="onClickPreviewData(item.image, idx)"
															:src="imgInfo.imgUrl"
															:fit="imageStyleMap[dataHandleOpts.styleInfo.imageStyle]"
														>
														</van-image>
													</van-swipe-item>
												</van-swipe>
											</template>

											<template v-else-if="item.image.fieldId.includes('ATTACHMENT_')">
												<template v-if="item.image.showData.length === 1">
													<div
														@click.stop="onClickPreviewData(item.image, 0)"
														class="file__icon"
														v-if="!item.image.showData[0].fileType.includes('image')"
													>
														<svg
															class="icon"
															aria-hidden="true"
														>
															<use
																:xlink:href="actionFileType2FileImage(item.image.showData[0])">
															</use>
														</svg>
													</div>
													<van-image
														@click.stop="onClickPreviewData(item.image, 0)"
														v-else
														:src="item.image.showData[0].fileUrl"
														:fit="imageStyleMap[dataHandleOpts.styleInfo.imageStyle]"
													>
													</van-image>
												</template>

												<van-swipe
													v-else
													:autoplay="dataHandleOpts.styleInfo.autoplay === 'YES' ? 3000 : 0"
													lazy-render
													style="height: 100%; width: 100%;"
												>
													<van-swipe-item
														v-for="(imgInfo, idx) in item.image.showData"
														:key="imgInfo.id"
													>
														<div
															@click.stop="onClickPreviewData(item.image, idx)"
															class="file__icon"
															v-if="!imgInfo.fileType.includes('image')"
														>
															<svg
																class="icon"
																aria-hidden="true"
															>
																<use :xlink:href="actionFileType2FileImage(imgInfo)">
																</use>
															</svg>
														</div>
														<van-image
															@click.stop="onClickPreviewData(item.image, idx)"
															v-else
															:src="imgInfo.fileUrl"
															:fit="imageStyleMap[dataHandleOpt.styleInfo.imageStyle]"
														>
														</van-image>
													</van-swipe-item>
												</van-swipe>
											</template>

											<div v-else>
												<qriously
													:value="item.image.showData[0]"
													:size="160"
												/>
											</div>
										</template>
										<van-image
											v-else
											:src="`${$BASE_PATH}/fetch/image?id=344442529678098433.png`"
											fit="cover"
										>
										</van-image>

									</div>
									<div class="card-info">
										<div class="title">

										</div>
										<p
											class="show-time"
											v-if="dataHandleOpts.styleInfo.showTime"
										>
											<span class="color">
											</span>
											{{actionFormatTime(item.time.showData,item.time.formatStr)}}
										</p>
										<h3 v-if="dataHandleOpts.styleInfo.showTitle">{{item.title.showData}}</h3>
										<div
											class="card-info-row"
											:class="{'compact-card' : dataHandleOpts.styleInfo.displayType === 'COMPACT'}"
										>
											<div
												class="row-item"
												v-for="showData in item.content"
												:key="showData.dataId"
												:style="{display: opts.includes(showData.type) ? 'flex' : 'block',  alignItems: 'center'}"
											>
												<h5
													v-if="dataHandleOpts.styleInfo.showFieldTitle"
													style="margin-right: 10px"
												>{{showData.fieldTitle}}:</h5>
												<div
													class="item-content"
													:class="{'line-item-content' : dataHandleOpts.styleInfo.displayType === 'COMPACT'}"
												>
													<FieldShowData
														:show-data="showData"
														:memberShowType="dataHandleOpts.styleInfo.memberShowType"
														:lineFeed="dataHandleOpts.styleInfo.displayType === 'NORMAL'"
													></FieldShowData>
												</div>
											</div>
										</div>
									</div>
									<div
										class="sub-table-container"
										v-if="dataHandleOpts.styleInfo.showTable === 'YES'"
									>
										<ScrollTable
											v-if="item.tableInfo.yList && item.tableInfo.yList.length"
											:y-list="item.tableInfo.yList"
											:x-field="item.tableInfo.xField"
											:x-list="item.tableInfo.xList"
											:width-info="item.tableInfo.widthInfo"
										></ScrollTable>
									</div>
								</div>

							</div>
						</div>

					</van-list>
				</div>

				<div
					class="batch-handle-container"
					v-if="isBatchSelect"
				>
					<div class="select-num">已选中 <span>{{selectList.length}}</span> 条</div>
					<div class="bottom-container">
						<van-checkbox
							v-model="allSelect"
							@change="onClickAllSelect"
						>全选本页</van-checkbox>
						<div>
							<div
								class="handle-cancel-button"
								@click="cancelSelect"
							>取消操作</div>
							<div class="handle-button-container">
								<div
									class="agree-button"
									@click="batchPrint"
								>
									批量打印标签
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>

			<div
				v-if="loadingEnd && dataHandleOpts.totalCount === 0"
				class="empty-data-container"
			>
				<img
					src="../../assets/images/empty.png"
					alt=""
				>
				暂无数据
			</div>
		</template>
		<template v-if="[FORM_VIEW_TYPE_MAP_PATH_VIEW].includes(viewType)">
			<TrackMapView
				:form-id="formId"
				:view-id="viewId"
				@onClickData="toDataDetail"
			></TrackMapView>
		</template>

		<template v-if="[FORM_VIEW_TYPE_MAP_BUBBLE_VIEW].includes(viewType)">
			<BubbleMapView
				:form-id="formId"
				:view-id="viewId"
				@onClickData="toDataDetail"
			></BubbleMapView>
		</template>

		<div
			class="list-skeleton-container"
			v-if="!loadingEnd"
		>
			<div class="skeleton"></div>
			<div class="skeleton"></div>
			<div class="skeleton"></div>
			<div class="skeleton"></div>
		</div>

		<div
			v-if="hasAddForm && hasFillForm"
			class="add-button"
			@click="onClickAddForm"
		>
			<i class="el-icon-plus"></i>
		</div>

		<create-form-apply
			v-if="originalFormSet"
			ref="createFormApply"
			:appId="appId"
			:formId="formId"
			:needButton="false"
			:reqDefaultSubmitData="false"
			@formSetFinalComplete="createFormComplete"
			@submitCallback="submitCallback"
		>
		</create-form-apply>
		<!--选择sort-->
		<van-popup
			class="select-sort-popup"
			v-model="sortVisible"
			:style="{ width: '80%' }"
			get-container="body"
			position="right"
		>
			<div class="header">
				<span @click="clearSort">清空</span>
			</div>
			<div class="sort-container">
				<div v-for="item in sortFields">
					<div class="item-title">
						{{item.fieldTitle}}
						<span>{{item.sort === 1 ? '(升序)' : item.sort === -1 ? '(降序)' : ''}}</span>
					</div>
					<div class="select-sort">
						<van-radio-group v-model="item.sort">
							<van-cell-group>
								<van-cell
									title="升序"
									clickable
									@click="ascending(item)"
								>
									<template #right-icon>
										<van-radio :name="1" />
									</template>
								</van-cell>
								<van-cell
									title="降序"
									clickable
									@click="descending(item)"
								>
									<template #right-icon>
										<van-radio :name="-1" />
									</template>
								</van-cell>
							</van-cell-group>
						</van-radio-group>
					</div>
				</div>
			</div>
		</van-popup>

		<gallery
			:images="previewData"
			:index="index"
			@close="index = null"
		></gallery>
	</div>
</template>

<script>
	import {
		FORM_VIEW_TYPE_WRITE_FORM,
		FORM_VIEW_TYPE_DATA_HANDLE,
		FORM_VIEW_TYPE_DATA_VIEW,
		FORM_VIEW_TYPE_BOARD_VIEW,
		FORM_VIEW_TYPE_PHOTO,
		FORM_VIEW_TYPE_MAP_PATH_VIEW,
		FORM_VIEW_TYPE_MAP_BUBBLE_VIEW,
	} from "../../assets/types/index"
	import RyFormSet from '../RyForm'
	import {
		clone,
		formatDate,
		isIDCard,
		isPhone,
		hiddenStr,
		fileType2FileImage,
		arrayRemove
	} from "../../assets/js/Untis"
	import FieldShowData from "../component/FieldShowData";
	import ScrollTable from "./SryTable/ScrollTable";
	import FormDataFilter from "../component/FormDataFilter";
	import {
		DATE_TYPE__SECTION,
		FORM_ITEM__BUTTON,
		FORM_ITEM__DATE,
		FORM_ITEM__RELATE_RECORD,
		FORM_TYPE__FILL
	} from "../RyForm/types";
	import {
		SUCCESS
	} from "../store/types";
	import VueGallery from 'vue-gallery';
	import CreateFormApply from "./CreateFormApply";
	import TrackMapView from "./TrackMapView";
	import BubbleMapView from "./BubbleMapView";

	export default {
		components: {
			FieldShowData,
			ScrollTable,
			CreateFormApply,
			'gallery': VueGallery,
			TrackMapView,
			BubbleMapView
		},
		props: {
			appId: {
				type: String,
				default: ''
			},
			formId: {
				type: String,
				default: ''
			},
			viewId: {
				type: String,
				default: ''
			},
			instanceId: {
				type: String,
				default: ''
			},
			viewType: {
				type: String,
				default: FORM_VIEW_TYPE_DATA_HANDLE
			},
			hasAddForm: {
				type: Boolean,
				default: true
			},
			// 点击一条数据时的提示
			clickRowTips: {
				type: String,
				default: ''
			},
			activeRelateForm: Object,
			originalFormSet: Object
		},
		data() {
			return {
				aEle: null,

				opts: [
					RyFormSet.TYPES.FORM_ITEM__FLOW_DETAIL_INFO,
					RyFormSet.TYPES.FORM_ITEM__FORM_RUN_STATUS,
					RyFormSet.TYPES.FORM_ITEM__ARCHIVE,
					RyFormSet.TYPES.FORM_ITEM__DATE,
					RyFormSet.TYPES.FORM_ITEM__FLOW_DETAIL_INFO,
					RyFormSet.TYPES.FORM_ITEM__FORM_RUN_STATUS,
					RyFormSet.TYPES.FORM_ITEM__ARCHIVE,
					RyFormSet.TYPES.FORM_ITEM__DATE,
					RyFormSet.TYPES.FORM_ITEM__NUMBER,
					RyFormSet.TYPES.FORM_ITEM__CURRENCY,
					RyFormSet.TYPES.FORM_ITEM__YES_NO,
					RyFormSet.TYPES.FORM_ITEM__GRADE,
					RyFormSet.TYPES.FORM_ITEM__SLIDING_BLOCK,
					RyFormSet.TYPES.FORM_ITEM__PHONE,
					RyFormSet.TYPES.FORM_ITEM__SERIAL_NUMBER,
					RyFormSet.TYPES.FORM_ITEM__DROPDOWN,
					RyFormSet.TYPES.FORM_ITEM__SINGLE_CHOOSE,
					RyFormSet.TYPES.FORM_ITEM__MEMBER,
					RyFormSet.TYPES.FORM_ITEM__DEPARTMENT,
					RyFormSet.TYPES.FORM_ITEM__CURRENT_VIEW_USER,
				],
				FORM_VIEW_TYPE_WRITE_FORM,
				FORM_VIEW_TYPE_DATA_HANDLE,
				FORM_VIEW_TYPE_DATA_VIEW,
				FORM_VIEW_TYPE_BOARD_VIEW,
				FORM_VIEW_TYPE_PHOTO,
				FORM_VIEW_TYPE_MAP_PATH_VIEW,
				FORM_VIEW_TYPE_MAP_BUBBLE_VIEW,
				loadingEnd: false,
				sortVisible: false,
				formSet: new RyFormSet(),

				loading: false,
				finished: false,
				hasFillForm: false,
				dataHandleOpts: {
					request: false,
					styleInfo: null,

					selectList: [],
					header: [],

					dataList: [],
					currentPage: 0,
					pageSize: 200,
					totalPage: 0,
					totalCount: 0,
					sort: {},
					filter: null,
					// 当前选中的数据
					selectionList: [],

					requestInfo: {
						requestToken: '',
						dataMaxIndex: 0,
						slotDataMaxIndex: 0,
						maxSlotId: '',
						pageSize: 30,
						hasNext: 'NO'
					}
				},
				listKey: Math.random(),

				imageStyleMap: {
					'STRETCH': 'fill',
					'CENTER': 'contain',
					'SELF_ADAPTION': 'cover'
				},
				index: null,
				previewData: [],

				isBatchSelect: false,
				selectList: [],
				allSelect: false,
				printPermission: 'NO'
			}
		},
		created() {

			const {
				companyId,
				userId
			} = this.$store.state
			console.log('state', this.$store.state)
			this.formSet.companyId = companyId
			this.formSet.userId = userId
			this.formSet.appId = this.appId
			this.formSet.formId = this.formId
			this.formSet.isInit = true

			this.$store.dispatch('actionMergeStructure', {
					formType: FORM_TYPE__FILL,
					viewType: 0,
				})
				.then(({
					status,
					resultObject,
					info
				}) => {
					if (status === SUCCESS) {
						this.formSet.setStructure(resultObject.structureInfo)
						this.formSet.setPermission(resultObject.permissionInfo.permissionList)
						this.formSet.setConf(resultObject.detailInfo)
						this.formSet.setWidth(resultObject.widthInfo)
						this.formSet.formName = resultObject.detailInfo.formName
					} else {
						throw new Error(`${status}: ${info}`)
					}
				})
				.catch(console.error)

			this.fetchApplyHeader()
			this.$store.dispatch('actionViewDataPrintPermission', {
				formId: this.formId,
				viewId: this.viewId
			}).then(res => {
				this.printPermission = res.print
			}).catch(console.error)
		},
		computed: {
			sortFields() {
				console.log(this.dataHandleOpts.header)
				return this.dataHandleOpts.header.filter(item => item.type !== FORM_ITEM__BUTTON && item.type !==
					FORM_ITEM__RELATE_RECORD)
			}
		},
		methods: {
			async fetchFormDataPhoneStyle(callback) {
				this.$store.dispatch('actionFormDataPhoneStyleGet', {
					appId: this.appId,
					formId: this.formId,
					viewId: this.viewId
				}).then(res => {
					this.dataHandleOpts.styleInfo = res
					if (callback) callback()
				}).catch(console.error)
			},

			fetchApplyHeader() {
				console.log('dataHandleOpts--', this.dataHandleOpts, this.viewType)
				if (!this.dataHandleOpts.request) {

					// 获取权限
					this.$store.dispatch('actionFormFillPermission', {
						appId: this.appId,
						formId: this.formId,
					}).then(res => {
						this.hasFillForm = res.hasPer
					}).catch(console.error)

					if (this.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
						this.$store.dispatch('actionApplyHeader', {
								formId: this.formId
							})
							.then((res = []) => {
								this.dataHandleOpts.request = true
								this.dataHandleOpts.header = res.map(item => {
									return {
										...item,
										sort: 0,
										show: true
									}
								})
								this.fetchFormDataPhoneStyle(() => {
									this.getManagementData()
								})
							}).catch(console.error)
					} else if ([FORM_VIEW_TYPE_DATA_VIEW, FORM_VIEW_TYPE_PHOTO].includes(this.viewType)) {

						this.$store.dispatch('actionFormDataViewHeader', {
								appId: this.appId,
								formId: this.formId,
								viewId: this.viewId
							})
							.then((res = []) => {
								this.dataHandleOpts.request = true
								this.dataHandleOpts.header = res.map(item => {
									return {
										...item,
										sort: 0,
										show: true
									}
								})
								this.fetchFormDataPhoneStyle(() => {
									this.getManagementData()
								})
							}).catch(console.error)
					}
				} else {
					if (!this.dataHandleOpts.styleInfo) {
						this.fetchFormDataPhoneStyle(() => {
							this.getManagementData()
						})
					}
					this.getManagementData()
				}
			},
			// 获取数据管理数据
			getManagementData() {
				if (this.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
					// 表单数据
					this.$store.dispatch('actionFetchRelateFormData', {
							appId: this.appId,
							formId: this.formId,
							data: this.formSet ? this.formSet.getValues() : null,
							instanceId: this.instanceId,
							currentPage: this.dataHandleOpts.currentPage,
							pageSize: this.dataHandleOpts.pageSize,
							sort: this.dataHandleOpts.sort,
							filterInfo: this.activeRelateForm.filterInfo
						}).then(({
							currentPage,
							dataList,
							totalPage,
							totalCount,
							timestamp
						}) => {
							let showDataList = []
							dataList.forEach(item => {
								let showData = {
									title: {},
									color: {},
									time: {},
									image: {},
									content: [],
									tableInfo: {},
									item
								}
								if (this.dataHandleOpts.styleInfo.showTitle) {
									showData.title = {
										showData: item[this.dataHandleOpts.styleInfo.titleFieldId],
										fieldId: this.dataHandleOpts.styleInfo.titleFieldId,
										type: 'title'
									}
								}
								// 卡片颜色
								if (this.dataHandleOpts.styleInfo.showColor === 1) {
									// 获取当前选择的选项的id
									const optId = item[this.dataHandleOpts.styleInfo.colorFieldId]
									const field = this.dataHandleOpts.header.filter(field => field.dataId ===
										this.dataHandleOpts.styleInfo.colorFieldId)[0]
									let opt = null
									if (field) {
										opt = field.options.filter(opt => opt.id === optId)[0]
									}
									showData.color = {
										showData: opt ? opt.color : '',
										fieldId: this.dataHandleOpts.styleInfo.colorFieldId,
										type: 'color'
									}
								}
								// 时间
								if (this.dataHandleOpts.styleInfo.showTime) {
									showData.time = {
										showData: item[this.dataHandleOpts.styleInfo.timeFieldId],
										fieldId: this.dataHandleOpts.styleInfo.timeFieldId,
										type: 'title'
									}
								}
								// 图片
								if (this.dataHandleOpts.styleInfo.showImage) {
									if (this.dataHandleOpts.styleInfo.imageFieldId.includes('IMAGE_')) {
										const imgArr = item[this.dataHandleOpts.styleInfo.imageFieldId]
										showData.image = {
											showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											type: 'title'
										}
									} else {
										showData.image = {
											showData: item[this.dataHandleOpts.styleInfo.imageFieldId],
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											type: 'title'
										}
									}
								}

								this.dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
									let field = this.dataHandleOpts.header.filter(field => field
										.dataId === fieldId)[0]
									if (field) {
										showData.content.push({
											showData: item[fieldId],
											type: field.type,
											...field
										})
									}
								})

								if (this.dataHandleOpts.styleInfo.showTable === 'YES') {
									let tableField = this.dataHandleOpts.header.filter(field => field
										.dataId === this.dataHandleOpts.styleInfo.tableFieldId)[0]

									if (tableField) {
										const xList = []
										const widthInfo = {}
										tableField.tableFieldList.forEach(item => {
											if (this.dataHandleOpts.styleInfo.subTableFieldIdList
												.includes(item.dataId)) {
												xList.push({
													field_name: item.dataId,
													name: item.fieldTitle,
													colspan: 1, //指定单元格 横向 跨越的 列数
													rowspan: 1, //指定单元格 纵向 跨越的 行数
												})

												const field = this.formSet.fields[item.dataId]
												if (field) {
													widthInfo[item.dataId] = field.width
												}
											}
										})

										const yList = []
										if (item[this.dataHandleOpts.styleInfo.tableFieldId]) {
											item[this.dataHandleOpts.styleInfo.tableFieldId].forEach(row => {
												const rowValObj = {}
												Object.keys(row).forEach(fieldId => {
													const val = row[fieldId]
													if (this.dataHandleOpts.styleInfo
														.subTableFieldIdList.includes(fieldId)
														) {
														const newVal = this.formSet
															.valueToString(fieldId, val)
														this.$set(rowValObj, fieldId, newVal)
													}
												})
												yList.push(rowValObj)
											})
										}

										this.$set(showData.tableInfo, 'xList', [xList])
										this.$set(showData.tableInfo, 'xField', this.dataHandleOpts.styleInfo
											.subTableFieldIdList)
										this.$set(showData.tableInfo, 'yList', yList)
										this.$set(showData.tableInfo, 'widthInfo', widthInfo)
									}
								}

								showDataList.push(showData)
							})
							this.dataHandleOpts.dataList.push(...showDataList)
							this.dataHandleOpts.totalPage = totalPage
							this.dataHandleOpts.currentPage = currentPage
							this.dataHandleOpts.totalCount = totalCount
							if (totalPage <= currentPage) {
								this.finished = true
							}
							this.refreshRelateData()
						})
						.catch(console.error)
						.finally(() => {
							this.loadingEnd = true
							this.loading = false
						})

				} else if (this.viewType === FORM_VIEW_TYPE_DATA_VIEW) {
					// 数据视图
					this.$store.dispatch('actionFetchFormViewDetail', {
							formId: this.formId,
							viewId: this.viewId
						}).then(res => {
							this.viewSet = res
							return this.$store.dispatch('actionFormDataViewData', {
								appId: this.appId,
								formId: this.formId,
								viewId: this.viewId,
								data: this.formSet ? this.formSet.getValues() : null,
								instanceId: this.instanceId,
								currentPage: this.dataHandleOpts.currentPage + 1,
								pageSize: this.dataHandleOpts.pageSize,
								sortList: Object.keys(this.dataHandleOpts.sort).map(key => {
									return {
										fieldId: key,
										sortType: this.dataHandleOpts.sort[key]
									}
								}),
								filter: this.activeRelateForm.filterInfo
							})
						})
						.then(({
							currentPage,
							dataList,
							totalPage,
							totalCount,
							timestamp
						}) => {
							let showDataList = []
							dataList.forEach(item => {
								let showData = {
									title: {},
									color: {},
									time: {},
									image: {},
									content: [],
									tableInfo: {},
									item
								}
								if (this.dataHandleOpts.styleInfo.showTitle) {
									showData.title = {
										showData: item[this.dataHandleOpts.styleInfo.titleFieldId],
										fieldId: this.dataHandleOpts.styleInfo.titleFieldId,
										type: 'title'
									}
								}
								// 卡片颜色
								if (this.dataHandleOpts.styleInfo.showColor === 1) {
									// 获取当前选择的选项的id
									const optId = item[this.dataHandleOpts.styleInfo.colorFieldId]
									const field = this.dataHandleOpts.header.filter(field => field.dataId ===
										this.dataHandleOpts.styleInfo.colorFieldId)[0]
									let opt = null
									if (field) {
										opt = field.options.filter(opt => opt.id === optId)[0]
									}
									showData.color = {
										showData: opt ? opt.color : '',
										fieldId: this.dataHandleOpts.styleInfo.colorFieldId,
										type: 'color'
									}
								}
								// 时间
								if (this.dataHandleOpts.styleInfo.showTime) {
									showData.time = {
										showData: item[this.dataHandleOpts.styleInfo.timeFieldId],
										fieldId: this.dataHandleOpts.styleInfo.timeFieldId,
										type: 'title'
									}
								}
								// 图片
								if (this.dataHandleOpts.styleInfo.showImage) {
									if (this.dataHandleOpts.styleInfo.imageFieldId.includes('IMAGE_')) {
										const imgArr = item[this.dataHandleOpts.styleInfo.imageFieldId]
										showData.image = {
											showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											type: 'title'
										}
									} else {
										showData.image = {
											showData: item[this.dataHandleOpts.styleInfo.imageFieldId],
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											type: 'title'
										}
									}
								}

								this.dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
									let field = this.dataHandleOpts.header.filter(field => field
										.dataId === fieldId)[0]
									if (field) {
										let value = item[fieldId]
										if (this.viewType === FORM_VIEW_TYPE_DATA_VIEW &&
											this.viewSet &&
											this.viewSet.partHiddenFieldList &&
											this.viewSet.partHiddenFieldList.length &&
											this.viewSet.partHiddenFieldList.includes(fieldId)) {
											if (isPhone(value)) {
												value = hiddenStr(value, 3, 4)
											} else if (isIDCard(value)) {
												value = hiddenStr(value, 6, 4)
											} else if (value.length > 2) {
												value = hiddenStr(value, 1, 1)
											}
										}
										showData.content.push({
											showData: value,
											type: field.type,
											...field
										})
									}
								})

								if (this.dataHandleOpts.styleInfo.showTable === 'YES') {
									let tableField = this.dataHandleOpts.header.filter(field => field
										.dataId === this.dataHandleOpts.styleInfo.tableFieldId)[0]

									if (tableField) {
										const xList = []
										const widthInfo = {}
										tableField.tableFieldList.forEach(item => {
											if (this.dataHandleOpts.styleInfo.subTableFieldIdList
												.includes(item.dataId)) {
												xList.push({
													field_name: item.dataId,
													name: item.fieldTitle,
													colspan: 1, //指定单元格 横向 跨越的 列数
													rowspan: 1, //指定单元格 纵向 跨越的 行数
												})

												const field = this.formSet.fields[item.dataId]
												if (field) {
													widthInfo[item.dataId] = field.width
												}
											}
										})

										const yList = []
										if (item[this.dataHandleOpts.styleInfo.tableFieldId]) {
											item[this.dataHandleOpts.styleInfo.tableFieldId].forEach(row => {
												const rowValObj = {}
												Object.keys(row).forEach(fieldId => {
													const val = row[fieldId]
													if (this.dataHandleOpts.styleInfo
														.subTableFieldIdList.includes(fieldId)
														) {
														const newVal = this.formSet
															.valueToString(fieldId, val)
														this.$set(rowValObj, fieldId, newVal)
													}
												})
												yList.push(rowValObj)
											})
										}

										this.$set(showData.tableInfo, 'xList', [xList])
										this.$set(showData.tableInfo, 'xField', this.dataHandleOpts.styleInfo
											.subTableFieldIdList)
										this.$set(showData.tableInfo, 'yList', yList)
										this.$set(showData.tableInfo, 'widthInfo', widthInfo)
									}
								}

								showDataList.push(showData)
							})
							this.dataHandleOpts.dataList.push(...showDataList)
							this.dataHandleOpts.totalPage = totalPage
							this.dataHandleOpts.currentPage = currentPage
							this.dataHandleOpts.totalCount = totalCount
							if (totalPage <= currentPage) {
								this.finished = true
							}
							this.refreshRelateData()
						}).catch(console.error)
						.finally(() => {
							this.loadingEnd = true
							this.loading = false
						})
				} else if (this.viewType === FORM_VIEW_TYPE_PHOTO) {

					if (this.dataHandleOpts.dataList) {
						const lastData = this.dataHandleOpts.dataList[this.dataHandleOpts.dataList.length - 1]
						if (lastData && lastData.item) {
							this.dataHandleOpts.requestInfo.slotDataMaxIndex = lastData.item.slotDataIndex
							this.dataHandleOpts.requestInfo.maxSlotId = lastData.item.slotId
						}
					}


					this.$store.dispatch('actionFetchFormViewDetail', {
							formId: this.formId,
							viewId: this.viewId
						}).then(res => {
							this.viewSet = res
							return this.$store.dispatch('actionFormViewPhotoData', {
								formId: this.formId,
								viewId: this.viewId,
								sort: this.dataHandleOpts.sort,
								filterInfo: this.activeRelateForm.filterInfo,
								...this.dataHandleOpts.requestInfo
							})
						})
						.then(res => {
							this.dataHandleOpts.requestInfo.hasNext = res.hasNext
							this.dataHandleOpts.requestInfo.requestToken = res.requestToken
							this.dataHandleOpts.requestInfo.dataMaxIndex = res.dataMaxIndex
							this.dataHandleOpts.totalCount = res.totalCount

							let showDataList = []
							res.dataList.forEach(item => {
								let showData = {
									title: {},
									color: {},
									time: {},
									image: {},
									content: [],
									tableInfo: {},
									item
								}
								if (this.dataHandleOpts.styleInfo.showTitle) {
									showData.title = {
										showData: item[this.dataHandleOpts.styleInfo.titleFieldId],
										fieldId: this.dataHandleOpts.styleInfo.titleFieldId,
										type: 'title'
									}
								}
								// 卡片颜色
								if (this.dataHandleOpts.styleInfo.showColor === 1) {
									// 获取当前选择的选项的id
									const optId = item[this.dataHandleOpts.styleInfo.colorFieldId]
									const field = this.dataHandleOpts.header.filter(field => field.dataId ===
										this.dataHandleOpts.styleInfo.colorFieldId)[0]
									let opt = null
									if (field) {
										opt = field.options.filter(opt => opt.id === optId)[0]
									}
									showData.color = {
										showData: opt ? opt.color : '',
										fieldId: this.dataHandleOpts.styleInfo.colorFieldId,
										type: 'color'
									}
								}
								// 时间
								if (this.dataHandleOpts.styleInfo.showTime) {
									const field = this.dataHandleOpts.header.filter(field => field.dataId ===
										this.dataHandleOpts.styleInfo.timeFieldId)[0]
									showData.time = {
										showData: item[this.dataHandleOpts.styleInfo.timeFieldId],
										fieldId: this.dataHandleOpts.styleInfo.timeFieldId,
										...field,
										type: 'title'
									}
								}
								// 图片
								if (this.dataHandleOpts.styleInfo.showImage) {
									if (!this.dataHandleOpts.styleInfo.imageFieldId) {
										showData.image = {
											showData: [],
											fieldId: '',
											type: 'title'
										}
									} else if (this.dataHandleOpts.styleInfo.imageFieldId.includes('IMAGE_')) {
										const imgArr = item[this.dataHandleOpts.styleInfo.imageFieldId]
										showData.image = {
											showData: imgArr && imgArr.length > 0 ? imgArr : [],
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											previewData: imgArr ? imgArr.map(image => {
												return {
													title: image.imgName,
													type: 'image/png',
													href: image.imgUrl,
													poster: '',
													thumbnail: image.imgUrl
												}
											}) : [],
											type: 'title'
										}
									} else if (this.dataHandleOpts.styleInfo.imageFieldId.includes(
											'ATTACHMENT_')) {
										const imgArr = item[this.dataHandleOpts.styleInfo.imageFieldId]
										showData.image = {
											show: true,
											showData: imgArr && imgArr.length > 0 ? imgArr.filter(item => [
												'#icon-WAV', '#icon-mp', '#icon-tupian'
											].includes(fileType2FileImage(item.fileType))) : [],
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											previewData: imgArr ? imgArr.map(file => {
												return {
													title: file.fileName,
													type: file.fileType,
													href: file.fileUrl,
													poster: '',
													thumbnail: file.fileUrl
												}
											}).filter(item => ['#icon-WAV', '#icon-mp', '#icon-tupian']
												.includes(fileType2FileImage(item.type))) : [],
											type: 'title'
										}
									} else {
										showData.image = {
											showData: [item[this.dataHandleOpts.styleInfo.imageFieldId]],
											fieldId: this.dataHandleOpts.styleInfo.imageFieldId,
											type: 'title'
										}
									}

								}

								this.dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
									let field = this.dataHandleOpts.header.filter(field => field
										.dataId === fieldId)[0]
									if (field) {
										let value = item[fieldId]
										if (this.viewType === FORM_VIEW_TYPE_DATA_VIEW &&
											this.viewSet &&
											this.viewSet.partHiddenFieldList &&
											this.viewSet.partHiddenFieldList.length &&
											this.viewSet.partHiddenFieldList.includes(fieldId)) {
											if (isPhone(value)) {
												value = hiddenStr(value, 3, 4)
											} else if (isIDCard(value)) {
												value = hiddenStr(value, 6, 4)
											} else if (value.length > 2) {
												value = hiddenStr(value, 1, 1)
											}
										}
										showData.content.push({
											showData: value,
											type: field.type,
											...field
										})
									}
								})

								if (this.dataHandleOpts.styleInfo.showTable === 'YES') {
									let tableField = this.dataHandleOpts.header.filter(field => field
										.dataId === this.dataHandleOpts.styleInfo.tableFieldId)[0]

									if (tableField) {

										const xList = []
										const widthInfo = {}
										tableField.tableFieldList.forEach(item => {
											if (this.dataHandleOpts.styleInfo.subTableFieldIdList
												.includes(item.dataId)) {
												xList.push({
													field_name: item.dataId,
													name: item.fieldTitle,
													colspan: 1, //指定单元格 横向 跨越的 列数
													rowspan: 1, //指定单元格 纵向 跨越的 行数
												})

												const field = this.formSet.fields[item.dataId]
												if (field) {
													widthInfo[item.dataId] = field.width
												}
											}
										})

										const yList = []
										if (item[this.dataHandleOpts.styleInfo.tableFieldId]) {
											item[this.dataHandleOpts.styleInfo.tableFieldId].forEach(row => {
												const rowValObj = {}
												Object.keys(row).forEach(fieldId => {
													const val = row[fieldId]
													if (this.dataHandleOpts.styleInfo
														.subTableFieldIdList.includes(fieldId)
														) {
														const newVal = this.formSet
															.valueToString(fieldId, val)
														this.$set(rowValObj, fieldId, newVal)
													}
												})
												yList.push(rowValObj)
											})
										}

										this.$set(showData.tableInfo, 'xList', [xList])
										this.$set(showData.tableInfo, 'xField', this.dataHandleOpts.styleInfo
											.subTableFieldIdList)
										this.$set(showData.tableInfo, 'yList', yList)
										this.$set(showData.tableInfo, 'widthInfo', widthInfo)
									}
								}

								showDataList.push(showData)
							})
							this.dataHandleOpts.dataList.push(...showDataList)

							console.log('data--', this.dataHandleOpts.dataList)
							if (res.hasNext === 'NO') {
								this.finished = true
							}
						}).catch(console.error)
						.finally(() => {
							this.loadingEnd = true
							this.loading = false
							if (this.toast) this.toast.clear()
						})
				}

			},

			refreshRelateData() {
				const relateFieldList = []
				this.dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
					let field = this.dataHandleOpts.header.filter(field => field.dataId === fieldId)[0]
					if (field && field.type === FORM_ITEM__RELATE_RECORD) {
						relateFieldList.push(field)
					}
				})
				relateFieldList.forEach(field => {

					const instanceIdList = []
					this.dataHandleOpts.dataList.forEach(item => {
						const value = item.content.filter(c => c.dataId === field.dataId)[0]
						if (value && value.showData) {
							instanceIdList.push(...value.showData.instanceIdList)
						}
					})

					Promise.all([
							this.$store.dispatch('actionLiteMergeStructure', {
								appId: field.relateAppId,
								formId: field.relateFormId,
							}),
							this.$store.dispatch('actionApplyBatch', {
								appId: field.relateAppId,
								formId: field.relateFormId,
								instanceIdList
							})
						]).then(([structure, res]) => {

							let showDataMap = {}
							res.dataList.forEach((item, idx) => {
								let showData = {
									title: '',
									...item
								}
								// 处理title
								if (field.titleFieldId) {
									const relateField = structure.detailInfo.fieldList.filter(item =>
										item.dataId === field.titleFieldId)[0]
									let val = item[field.titleFieldId]
									console.log('relateField', relateField, field.titleFieldId,
										structure.detailInfo.fieldList)
									if (relateField.type === FORM_ITEM__DATE) {
										let format = 'yyyy-MM-dd'
										if (relateField.dateType === DATE_TYPE__SECTION) {
											format = 'yyyy-MM-dd HH:mm'
										}
										val = item[field.titleFieldId] ? formatDate(item[field
											.titleFieldId])(format) : ''
									}
									showData.title = val
								}
								showDataMap[item.instanceId] = showData
							})

							this.dataHandleOpts.dataList.forEach(item => {
								const value = item.content.filter(c => c.dataId === field.dataId)[0]
								if (value && value.showData) {
									value.key = Math.random()
									value.showData.showTitleList.splice(0, value.showData.showTitleList
										.length)
									value.showData.instanceIdList.forEach(instanceId => {
										if (showDataMap[instanceId]) {
											value.showData.showTitleList.push(showDataMap[
												instanceId])
										}
									})
								}
							})
							console.log('dataList---', this.dataHandleOpts.dataList)
							this.listKey = Math.random()
						})
						.catch(console.error)
				})
			},
			// 加载更多数据
			onLoad() {
				this.getManagementData()
			},
			actionFormatTime(d,formatStr) {
				return formatDate(d)(formatStr || 'yyyy-MM-dd')
			},

			// 表格行被点击
			rowClick(row) {

				if (this.isBatchSelect) {
					if (this.selectList.includes(row)) {
						this.itemSelectChange(false, row)
					} else {
						this.itemSelectChange(true, row)
					}
					return
				}
				if (this.$store.getters.isGuest) {
					this.$toast.fail('您暂无访问权限')
					return
				}
				console.log('row', row)
				if (this.clickRowTips) {
					this.$dialog.confirm({
						title: '提示',
						message: this.clickRowTips,
						confirmButtonText: '继续进入'
					}).then(() => {
						this.toDataDetail(row)
					}).catch(action => {})
				} else {
					this.toDataDetail(row)
				}
			},

			toDataDetail(row) {
				let showFields = []
				this.dataHandleOpts.selectList.forEach(item => {
					if (item.show) {
						showFields.push(item.dataId)
					}
				})

				if (this.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
					const param = {
						instanceId: row.item.instanceId,
						showFields,
						appId: this.appId,
						formId: this.formId
					}
					const toast = this.$toast.loading({
						message: '加载中...'
					})
					this.$store.dispatch('reqNodeSave', param).then(res => {
							this.$router.push({
								name: 'formDataDetail',
								query: {
									key: res.nodeKey
								}
							})
						})
						.catch(console.error)
						.finally(() => {
							toast.clear()
						})

				} else {
					const param = {
						instanceId: row.item.instanceId,
						showFields,
						stepId: row.item.stepId,
						viewId: this.viewId,
						appId: this.appId,
						formId: this.formId
					}
					const toast = this.$toast.loading({
						message: '加载中...'
					})
					this.$store.dispatch('reqNodeSave', param).then(res => {
							this.$router.push({
								name: 'formViewDataDetail',
								query: {
									key: res.nodeKey
								}
							})
						})
						.catch(console.error)
						.finally(() => {
							toast.clear()
						})
				}
			},

			// 排序
			onClickSort() {
				this.sortVisible = true
			},

			// 升序
			ascending(item) {
				this.dataHandleOpts.header.forEach(item => {
					item.sort = 0
				})
				item.sort = 1
				this.sortVisible = false
				this.dataHandleOpts.sort = {
					[item.dataId]: 1
				}
				this.restartRequest()
			},

			// 降序
			descending(item) {
				this.dataHandleOpts.header.forEach(item => {
					item.sort = 0
				})
				item.sort = -1
				this.sortVisible = false
				this.dataHandleOpts.sort = {
					[item.dataId]: -1
				}
				this.restartRequest()
			},

			clearSort() {
				this.dataHandleOpts.header.forEach(item => {
					item.sort = 0
				})
				this.dataHandleOpts.sort = {}
				this.restartRequest()
				this.sortVisible = false
			},

			onClickFilter() {
				if (this.$refs.formDataFilter) {
					this.$refs.formDataFilter.open(this.dataHandleOpts.filter)
				}
			},

			// 筛选选择完成
			actionSelectFilterComplete(filter) {
				this.dataHandleOpts.filter = filter
				this.restartRequest()
			},

			restartRequest() {
				this.loadingEnd = false
				this.finished = false
				this.dataHandleOpts.dataList.splice(0, this.dataHandleOpts.dataList.length)
				this.dataHandleOpts.currentPage = 0
				this.dataHandleOpts.totalPage = 0
				this.dataHandleOpts.totalCount = 0

				this.fetchApplyHeader()
			},

			onClickAddForm() {
				if (this.$refs.createFormApply) {
					this.$refs.createFormApply.onClickCreate()
					return
				}
				const toast = this.$toast.loading({
					message: '加载中...'
				})
				this.$store.dispatch('reqNodeSave', {
						appId: this.appId,
						formId: this.formId
					})
					.then(res => {
						this.$router.push({
							name: 'formInput',
							query: {
								key: res.nodeKey
							}
						})
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => {
						toast.clear()
					})
			},
			createFormComplete(formSet) {
				this.$store.dispatch('actionFormRelateApplyData', {
					appId: this.originalFormSet.appId,
					formId: this.originalFormSet.formId,
					data: this.originalFormSet.getValues(),
					relateAppId: this.appId,
					relateFormId: this.formId,
					createMap: this.activeRelateForm.createMap,
					tableHandleList: this.activeRelateForm.tableHandleList,
				}).then(res => {
					formSet.setValues(res)
				}).then(() => {
					return this.$store.dispatch('actionFormDefaultSubmitData', {
						appId: formSet.appId,
						formId: formSet.formId,
						data: formSet.getValues()
					})
				}).then(res => {
					formSet.setValues(res)
				}).catch(console.error)
			},

			submitCallback() {
				this.dataHandleOpts.dataList.splice(0, this.dataHandleOpts.dataList.length)
				this.dataHandleOpts.currentPage = 1
				this.getManagementData()
			},

			actionFileType2FileImage(item) {
				const icon = fileType2FileImage(item.fileType)
				return icon
			},
			onClickPreviewData(data, idx) {
				console.log('onClickPreviewData', data, idx)
				if (!data.previewData || !data.previewData.length) {
					return
				}
				this.previewData = data.previewData
				this.index = idx
			},

			onClickBatchHandle() {
				if (this.isBatchSelect) {
					return
				}
				this.isBatchSelect = true
			},
			// 全选
			onClickAllSelect(val) {
				this.selectList.splice(0, this.selectList.length)
				if (val) {
					this.selectList.push(...this.dataHandleOpt.dataList)
				}
			},
			// 取消批量操作
			cancelSelect() {
				this.allSelect = false
				this.selectList.splice(0, this.selectList.length)
				this.isBatchSelect = false
			},

			// 单个item选择
			itemSelectChange(val, item) {
				if (val) {
					this.selectList.push(item)
				} else {
					arrayRemove(this.selectList, item)
				}
			},
			batchPrint() {
				if (!this.selectList.length) {
					this.$toast.fail('请先选择打印数据')
					return
				}

				console.log(this.selectList)
				const loading = this.$toast.loading()
				const nodeValue = {
					formId: this.formId,
					viewId: this.viewId,
					company: this.$store.getters.currentCompany,
					companyId: this.$store.getters.currentCompanyId,
					userInfo: this.$store.state.userInfo,
					userId: this.$store.getters.userId,
					appId: this.$store.getters.currentAppId,
					token: this.$store.state.token,
					instanceIdList: this.selectList.map(item => item.item.instanceId),
					env: 'print',
				}
				this.$store.dispatch('actionNodeSave', nodeValue).then(res => {

						this.$store.dispatch('actionMiniappUrlScheme', {
							jumpPage: '/pages/print/index',
							queryParam: encodeURIComponent(`nodeKey=${res.nodeKey}`),
							envVersion: 'trial'
						}).then(res => {
							if (!this.aEle) this.aEle = document.createElement('a')
							this.aEle.href = res.openlink
							this.aEle.target = '_self'
							this.aEle.click()
						})
					}).catch(console.error)
					.finally(() => {
						loading.clear()
					})
			}
		}
	}
</script>

<style lang="less">
	.form-data-view-container {
		height: 100%;
		width: 100%;
		position: relative;

		>.header {
			height: 40px;
			background-color: #ffffff;
			/*border-top: 4px solid #F6F6F6;*/
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			border-bottom: 1px solid #e6e6e6;

			.des {
				color: #9f9f9f;
				font-size: 13px;
			}

			.van-icon {
				font-size: 20px;
				margin-left: 10px;
			}
		}

		.list-container {
			height: calc(100% - 40px);
			overflow: auto;
			-webkit-overflow-scrolling: touch;

			.photo-container {
				display: flex;
				flex-wrap: wrap;
			}

			.preview-container {
				z-index: 1;

				.preview-card {
					margin: 10px;
					position: relative;
					width: calc(100% - 20px);
					background-color: #fff;
					border-radius: 10px;
					// border: 1px solid #ebeef5;
					overflow: hidden;
					color: #303133;
					// box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

					.card-top-container {
						display: flex;
						width: 100%;
						position: relative;
						z-index: 2;
						background: #ffffff;

						.preview-card-wrapper {
							display: flex;
							flex: 1 1;
							width: calc(100% - 5px);
							position: relative;

							.card-tob-bj {
								height: 4px;
								width: 100%;
								position: absolute;
							}

							.card-info {
								flex: 1 1;
								width: calc(100% - 100px);
								border-radius: 2px;
								padding-left: 10px;
								padding-top: 15px;

								h3 {
									font-size: 14px;
									font-weight: 700;
									color: #262626;
									line-height: 1.5;
									margin:10px 0;
									width: 100%;
									word-break: break-all;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 3;
									-webkit-box-orient: vertical;
									white-space: pre-wrap;
								}

								.show-time {
									font-size: 15px;
									margin: 0;
									color: #000;

									//  .color {
									//    width: 8px;
									//    height: 8px;
									//    display: inline-block;
									//    border-radius: 50%;
									// background-color: #4A66FA;
									//  }

									&::after {
										content: ' ';
										height: 1px;
										width: 100%;
										background-color: #DEE3EC;
										display: inline-block;
										margin-left: -5px;
									}
								}

								.card-info-row {
									display: flex;
									// flex: 1 1;
									margin: 10px 0;
									flex-direction: column;
									justify-content: space-between;

									.row-item {
										flex: 1 1;
										display: flex;
										align-items: center;
										height: 30px;
										line-height: 30px;

										h5 {
											font-size: 13px;
											color: #979797;
											margin-right: 10px;
											white-space: nowrap;
											text-overflow: ellipsis;
											overflow: hidden;
											word-wrap: break-word;
										}

										.item-content {
											white-space: nowrap;
											text-overflow: ellipsis;
											overflow: hidden;
											word-wrap: break-word;
											max-width: 80%;
											display: flex;
											align-items: center;

											>div {
												padding-left: 0;
												padding-right: 0;
												margin-right: 8px;
												overflow: hidden;
												flex-wrap: nowrap;
												line-height: 30px;
												flex-grow: 1;
												word-break: break-all;
												text-overflow: ellipsis;
												white-space: nowrap;
												font-size: 13px;
												
												span,
												div{
													font-size: 13px;
												}
											}
										}
									}
								}
							}

							.img-container {
								border-radius: 1px;
								/*border: 1px solid #f0f0f6;*/
								display: flex;
								justify-content: center;
								align-items: center;

								.van-image {
									width: 90px;
									height: 90px;
								}
							}
						}
					}
				}

				.preview-photo {
					margin: 5px;
					position: relative;
					width: calc(50% - 10px);
					background-color: #fff;
					border-radius: 10px;
					border: 1px solid #ebeef5;
					overflow: hidden;
					color: #303133;
					box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

					.img-container {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 100%;
						height: 200px;

						.van-image {
							width: 100%;
							height: 100%;
						}
					}

					.card-info {
						padding: 10px 10px 0 10px;
						position: relative;
						z-index: 2;
						background: #ffffff;

						.title {
							display: flex;
							align-items: center;

							.color {
								width: 5px;
								height: 16px;
								margin-right: 5px;
							}

							h3 {
								font-size: 16px;
								font-weight: 700;
								color: #262626;
								line-height: 18px;
								margin: 10px 0;
								width: 100%;
								word-break: break-all;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 3;
								-webkit-box-orient: vertical;
								white-space: pre-wrap;
							}
						}


						p {
							font-size: 13px;
							margin: 0 0 10px 0;
							color: #959699;
						}

						.card-info-row {
							width: 100%;
							display: flex;
							flex-direction: column;
							flex: 1 1;

							.row-item {

								h5 {
									font-size: 11px;
									color: #979797;
									line-height: 16px;
									margin: 0;
									white-space: nowrap;
									text-overflow: ellipsis;
									overflow: hidden;
									word-wrap: break-word;
								}

								.item-content {
									display: flex;
									align-items: center;
									color: #262626;
									font-size: 14px;

									>div {
										width: 100%;
										height: auto;
										padding-left: 0;
										padding-right: 0;
										margin-right: 8px;

										>.field-show-data-content {
											width: 100%;
											/*word-break: break-all;*/
											/*overflow: hidden;*/
											/*text-overflow: ellipsis;*/
											/*display: -webkit-box;*/
											/*-webkit-line-clamp: 4;*/
											/*-webkit-box-orient: vertical;*/
											/*white-space: pre-wrap;*/
											line-height: 20px;
										}
									}
								}

								.line-item-content {
									height: auto;
									line-height: 25px;

									>div {
										height: auto;
										line-height: 25px;

										>div {
											height: auto;
											white-space: normal;
											line-height: 25px !important;

											.field-show-data-content {
												overflow: unset;
												line-height: 25px !important;
											}
										}
									}
								}
							}
						}

						.compact-card {
							flex-direction: row;
							flex-wrap: wrap;
						}
					}
				}
			}
		}

		.batch-handle-container {
			position: absolute;
			bottom: 0;
			right: 0;
			left: 0;
			height: 64px;
			background-color: #ffffff;

			.select-num {
				font-size: 14px;
				color: #7f828b;
				margin-left: 20px;
				margin-top: 10px;

				span {
					color: #E56833;
				}
			}

			.bottom-container {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.van-checkbox {
					margin-right: 10px;
					margin-left: 20px;

					.van-checkbox__icon {
						font-size: 16px;
					}

					>span {
						font-size: 14px;
					}
				}

				>div {
					display: flex;
					align-items: center;

					.handle-cancel-button {
						margin-right: 20px;
						font-size: 14px;
					}

					.handle-button-container {
						width: 100px;
						height: 34px;
						display: flex;
						align-items: center;
						color: #fff;
						font-size: 14px;
						border-radius: 4px;
						border: 1px solid #E56833;
						background-color: #E56833;
						margin: 5px;

						.agree-button {
							width: 120px;
							text-align: center;
						}

						.divider {
							width: 1px;
							height: 26px;
							margin: 0 10px 0 5px;
							background-color: #ffffff;
						}
					}
				}
			}
		}

		.list-skeleton-container {
			height: calc(100% - 40px);
			background-color: #ffffff;
			padding-top: 20px;

			.skeleton {
				margin: 10px;
				position: relative;
				width: calc(100% - 20px);
				height: 100px;
				background-color: #f2f3f5;
				border-radius: 10px;
				border: 1px solid #ebeef5;
			}
		}

		.add-button {
			position: absolute;
			bottom: 8px;
			right: 20px;
			border-radius: 50%;
			width: 44px;
			height: 44px;
			padding: 0;
			background-color: #4A66FA;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 9;

			i {
				font-size: 20px;
				color: #ffffff;
			}
		}
	}

	.select-sort-popup {
		height: 100%;

		.header {
			width: 100%;
			height: 30px;
			padding: 10px 20px;

			span {
				float: right;
				color: #05A971;
				font-size: 14px;
			}
		}

		.sort-container {
			height: calc(100% - 30px);
			overflow: auto;
			padding: 10px;

			.item-title {
				line-height: 30px;
				font-size: 16px;
				color: #333333;

				span {
					color: #4A66FA;
					font-size: 14px;
					margin-left: 10px;
				}
			}
		}
	}
</style>
